import {
  formSelector,
  getState,
  onlyIfForm,
  removeForm,
  setForm,
  updateForm,
  useSelector,
} from '../../../store.js'
import ConfirmModal from '../../../common/components/Modal/ConfirmModal.js'
import {showMessageToast} from '../../Header/Toast/index.js'
import {
  labelTypeSelector,
  maxWeightSelector,
  orderNumberFromLabelConfigSelector,
  orderTypeSelector,
  referenceIDFromLabelConfigSelector,
  updateParcel,
} from '../../../data/labelInfos/index.js'
import {getBulkRates} from '../BulkLabelConfigForm/bulkLabelConfigActions.js'
import {getRates} from '../../../data/labelInfos/rateRequest.js'
import WeightInput from '../../../common/components/Form/WeightInput.js'
import {LABEL_TYPE_SHIPPING} from '../../../common/constants/LabelConfig.js'
import {
  OT_RETURN_ORDER,
  OT_V3_ORDER,
} from '../../../common/constants/OrderTypes.js'
import {
  Count,
  IfPlural,
  IfSingle,
  Plural,
  PluralBlock,
} from '../../../common/components/Plural.js'
import delay from '../../../common/delay.js'

export const MODAL_FORM = 'edit_weight_modal'

export async function showEditWeightModal(labelInfoIDs, packagesIndex = 0) {
  const weight = maxWeightSelector(getState(), {labelInfoIDs})
  const orderType = orderTypeSelector(getState(), {
    labelInfoID: labelInfoIDs[0],
  })

  // count up shipping labels to know if this is mixed with shipping and return labels
  const shippingCount = labelInfoIDs.reduce(
    (count, labelInfoID) =>
      count +
      (labelTypeSelector(getState(), {labelInfoID}) === LABEL_TYPE_SHIPPING
        ? 1
        : 0),
    0,
  )

  // item count is
  // shipping label count if we more labelInfoIDs than shipping labels
  // otherwise labelInfoID count
  const itemCount =
    shippingCount && shippingCount !== labelInfoIDs.length
      ? shippingCount
      : labelInfoIDs.length

  const orderNumber =
    orderType === OT_V3_ORDER && itemCount === 1
      ? orderNumberFromLabelConfigSelector(getState(), {
          labelInfoID: labelInfoIDs[0],
        })
      : null
  const referenceID =
    orderType === OT_RETURN_ORDER && itemCount === 1
      ? referenceIDFromLabelConfigSelector(getState(), {
          labelInfoID: labelInfoIDs[0],
        })
      : null

  setForm(MODAL_FORM, {
    labelInfoIDs,
    orderType,
    itemCount,
    orderNumber,
    referenceID,
    packagesIndex,
    weight,
    isSaving: false,
    serverError: null,
  })
}

export function updateModalForm(updates) {
  updateForm(MODAL_FORM, updates)
}

export function closeModal() {
  removeForm(MODAL_FORM)
}

export function modalFormSelector(state) {
  return formSelector(state, {formName: MODAL_FORM})
}

export function errorsSelector(state) {
  const {lbError, ozError} = modalFormSelector(state)

  const errors = {}

  if (lbError || ozError) {
    errors.preventSave = true
  }

  return errors
}

export async function saveWeight() {
  try {
    updateModalForm({isSaving: true, serverError: null})

    // wait for inputs to finish debouncing
    await delay(500)

    const {labelInfoIDs, packagesIndex, weight} = modalFormSelector(getState())

    labelInfoIDs.map((labelInfoID) =>
      updateParcel(labelInfoID, packagesIndex, {weight}),
    )

    showMessageToast('Weight have been updated')

    closeModal()

    await getBulkRates(labelInfoIDs)

    await getRates(labelInfoIDs)
  } catch (error) {
    updateModalForm({
      serverError: error.message || error.error_message,
      isSaving: false,
    })
  }
}

function EditWeightModal({form}) {
  const errors = useSelector(errorsSelector)

  return (
    <ConfirmModal
      title="Edit Weight"
      confirmText="Save"
      cancelText="Cancel"
      modalSize="x-sm"
      isSaving={form.isSaving}
      isDisabled={errors.preventSave}
      onConfirm={() => saveWeight()}
      onCancel={() => closeModal()}
      error={form.serverError}
    >
      <ul className="list">
        <PluralBlock count={form.itemCount}>
          <li className="list__item--form list__item--no-style fs-n0 text--md-grey">
            <strong>
              Editing{' '}
              <IfSingle>{form.orderNumber || form.referenceID}</IfSingle>
              <IfPlural>
                <Count />{' '}
                <Plural
                  word={form.orderType === OT_V3_ORDER ? 'Order' : 'RMA'}
                />
              </IfPlural>
            </strong>
          </li>
        </PluralBlock>
        <li className="list__item--form list__item--no-style flex">
          <WeightInput
            idLb="id_weight-lb"
            idOz="id_weight-oz"
            weightOz={form.weight}
            setWeightOz={(weight) => updateModalForm({weight})}
            onErrorChange={({lb, oz}) =>
              updateModalForm({lbError: lb, ozError: oz})
            }
            showScaleControl
            autoFocus
          />
        </li>
      </ul>
    </ConfirmModal>
  )
}

export default onlyIfForm(EditWeightModal, modalFormSelector)
